import { render, staticRenderFns } from "./groupinfo.vue?vue&type=template&id=045a652f&scoped=true&"
import script from "./groupinfo.vue?vue&type=script&lang=js&"
export * from "./groupinfo.vue?vue&type=script&lang=js&"
import style0 from "./groupinfo.vue?vue&type=style&index=0&id=045a652f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a652f",
  null
  
)

export default component.exports